module.exports = __webpack_public_path__ + "img/golden3.abb6d365.svg";